import { clearGlobalMenuCache } from '@/hooks/usePortalMenu';
import { setAutoLogoutInProgress } from './config';
import { setNewUserSession, validateSession } from '@/hooks/useSession';

export const clearSessionCookies = () => {
  const cookieName = 'keystone-bff';
  const domain = window.location.hostname;
  const path = '/';

  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}; SameSite=Lax`;
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=.${domain}; SameSite=Lax`;
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=Lax`;
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

export const getLogoutUrl = (redirectUri: string): string => {
  return `${import.meta.env.VITE_FOUNDATION_API}/keystone/Authentication/logout?redirectUri=${encodeURIComponent(redirectUri)}`;
};

export const getLoginUrl = (redirectUri: string): string => {
  return `${import.meta.env.VITE_FOUNDATION_API}/keystone/Authentication/login?redirectUri=${encodeURIComponent(redirectUri)}`;
};

export const checkSessionValidity = async (): Promise<boolean> => {
  try {
    const sessionData = await validateSession();
    setNewUserSession(sessionData);
    return true;
  } catch {
    return false;
  }
};

const performCleanup = () => {
  clearSessionCookies();
  clearGlobalMenuCache();
};

export const performAutoAuth = (action: 'logout' | 'login') => {
  if (action === 'logout') {
    setAutoLogoutInProgress(true);
  }

  performCleanup();

  const currentPath = window.location.pathname;
  const baseUrl = window.location.origin;
  const redirectUri =
    currentPath === '/logout' ? baseUrl + '/' : window.location.href;
  const loginUrl = getLoginUrl(redirectUri);

  const url = action === 'logout' ? getLogoutUrl(loginUrl) : loginUrl;

  window.location.href = url;
};

export const performAutoLogout = () => {
  performAutoAuth('logout');
};

export const performAutoLogin = () => {
  performAutoAuth('login');
};
